import * as React from 'react';
import Popup, { PopupPlacement } from '../Popup/Popup';

export type DropdownProps = {
    isOpen: boolean;
    triggerRef: React.RefObject<HTMLElement>;
    portalRoot?: string;
    placement?: PopupPlacement;
    fullWidth?: boolean;
    onClose?: () => void;
};

const Dropdown: React.FunctionComponent<DropdownProps> = ({
    isOpen,
    onClose,
    triggerRef,
    portalRoot,
    placement = 'bottom-start',
    fullWidth,
    children,
}) => {
    return (
        <Popup
            isOpen={isOpen}
            onClose={onClose}
            portalRoot={portalRoot}
            triggerRef={triggerRef}
            hasCaret={false}
            hasShadow={true}
            placement={placement}
            fullWidth={fullWidth}
        >
            {children}
        </Popup>
    );
};

export default Dropdown;
